import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { of, Subscription } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { BaseService } from 'src/app/shared/services/base.service';
import * as config from '../../../app/shared/config/app.config';
import { CustomerHierarchyService } from '../customer-hierarchy.service';

@Component({
    selector: 'app-approver-deligates',
    templateUrl: './approver-deligates.component.html',
    styleUrls: ['./approver-deligates.component.scss'],
    standalone: false
})
export class ApproverDeligatesComponent implements OnInit {
  @Input() public index;
  @Input() aprroverDetails;
  @Input() parentNode: string;
  delegateForm: FormGroup;
  searchApproversList: any = [];
  b2bUnit: any;
  errorMsg: any = '';
  submitted: boolean;
  delegateSub: Subscription;
  baseSub: Subscription;
  serviceSub: Subscription;

  constructor(
    private readonly modalService: NgbModal,
    private readonly formBuilder: FormBuilder,
    private readonly cdr: ChangeDetectorRef,
    private readonly serviceClass: CustomerHierarchyService,
    private readonly baseService: BaseService
  ) {}

  ngOnInit(): void {
    this.baseSub = this.baseService
      .get(config.GET_ACCOUNT_ID)
      .pipe(take(1))
      .subscribe((res) => {
        this.b2bUnit = res?.defaultB2BUnit?.uid;
      });
    this.delegateForm = this.formBuilder.group({
      delegateName: ['', Validators.required],
      delegatePhoneNumber: ['', [Validators.pattern('[0-9-]{12}')]],
      delegateUid: ['', Validators.required],
    });
    this.delegateForm.patchValue(this.formValue());
    this.delegateSub = this.delegateForm.valueChanges.subscribe((value) => {
      this.submitted = false;
    });
  }
  formValue() {
    let val =
      this.index === 1
        ? this.aprroverDetails?.delegatesList[1]
        : this.aprroverDetails?.delegatesList[0];
    let obj = {
      delegateName: val?.delegate?.name,
      delegatePhoneNumber: val?.phoneNo,
      delegateUid: val?.delegate?.uid,
    };
    return obj;
  }
  searchApprovers() {
    let val = this.f.delegateName.value;
    this.f.delegateUid.setValue('');
    if (val !== '') {
      of(val)
        .pipe(
          switchMap((val) =>
            this.serviceClass.getSearchApprovers({
              contactType: 'delegate',
              customerUnit: this.b2bUnit,
              nodeOrApproverId: this.parentNode,
              searchText: val,
            })
          )
        )
        .subscribe(
          (res) => {
            if (res?.customers?.length > 0) {
              this.searchApproversList = res?.customers;
              this.searchApproversList.map(
                (item) => (item.nameEmail = `${item.name} (${item.email})`)
              );
            }
            this.cdr.detectChanges();
          },
          (error) => {
            this.searchApproversList = [];
          }
        );
    }
  }
  updateMySelection(event) {
    let value = event.option._element.nativeElement.OptionValue;
    this.f.delegateUid.setValue(value?.uid);
  }
  cancelPopup() {
    this.modalService.dismissAll();
  }
  get f(): any {
    return this.delegateForm.controls;
  }
  updateDelegate() {
    this.errorMsg = '';
    this.submitted = true;
    let node = {
      selectedNodeId: this.parentNode,
      contacts: this.updateDataCreate(),
    };
    this.serviceSub = this.serviceClass.addUpdateApprovers(node).subscribe(
      (res) => {
        if (res.status === 'Error') {
          this.errorMsg = res.errors[0];
          this.submitted = true;
          this.cdr.detectChanges();
        } else {
          this.modalService.dismissAll('success');
        }
      },
      (error) => {}
    );
  }
  updateDataCreate() {
    let obj = {
      approverName: this.aprroverDetails?.approver?.name,
      approverPhoneNumber: this.aprroverDetails?.phoneNo,
      approverUid: this.aprroverDetails?.approver?.uid,
      approverSapId: this.aprroverDetails?.uid,
      threshold: this.aprroverDetails?.thresholdValue,
      delegate1Name:
        this.index === 0
          ? this.f.delegateName.value
          : this.aprroverDetails?.delegatesList?.[0]?.delegate?.name,
      delegate1PhoneNumber:
        this.index === 0
          ? this.f.delegatePhoneNumber.value
          : this.aprroverDetails?.delegatesList?.[0]?.phoneNo,
      delegate1Uid:
        this.index === 0
          ? this.f.delegateUid.value
          : this.aprroverDetails?.delegatesList?.[0]?.delegate?.uid,
      delegate1SapId: this.aprroverDetails?.delegatesList?.[0]?.uid,
      delegate2Name:
        this.index === 1
          ? this.f.delegateName.value
          : this.aprroverDetails?.delegatesList?.[1]?.delegate?.name,
      delegate2PhoneNumber:
        this.index === 1
          ? this.f.delegatePhoneNumber.value
          : this.aprroverDetails?.delegatesList?.[1]?.phoneNo,
      delegate2Uid:
        this.index === 1
          ? this.f.delegateUid.value
          : this.aprroverDetails?.delegatesList?.[1]?.delegate?.uid,
      delegate2SapId: this.aprroverDetails?.delegatesList?.[1]?.uid,
    };
    return obj;
  }
}
